import { appHttpClient } from "../../installations/http/axiosInterfaces";

export const addOrder = (data) => {
  return appHttpClient.post(`/Order/Create`, data);
};

export const fetchOrders = (params) => {
  return appHttpClient.get(`/Order/List`, { params });
};

const orderService = {
  addOrder,
  fetchOrders,
};

export default orderService;
